export const createNumbersArray = (length: number): number[] => new Array(length)
  .fill(null)
  .map((n, ind) => ind);

export const ex = '';
